import { createTheme } from '@mui/material/styles';

// Orange theme matching iOS AR Catalog app
const theme = createTheme({
  palette: {
    primary: {
      main: '#FF7333',      // Vibrant Orange (iOS primary)
      light: '#FF9959',     // Light Orange (iOS primaryLight)
      dark: '#E6591A',      // Dark Orange (iOS primaryDark)
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FFB380',      // Soft Peach (iOS accent)
      light: '#FFE5D9',     // Very light peach
      dark: '#FF6147',      // Coral (iOS accentCoral)
    },
    success: {
      main: '#33C759',      // Modern Green (matching iOS)
    },
    warning: {
      main: '#FF9500',      // Warning Orange (matching iOS)
    },
    error: {
      main: '#FF453A',      // Modern Red (matching iOS)
    },
    background: {
      default: '#FAFAFC',   // Off-white (iOS background)
      paper: '#ffffff',     // Pure white (iOS tertiaryBackground)
    },
    text: {
      primary: '#1E1E26',   // Almost black (iOS primaryText)
      secondary: '#737380', // Medium gray (iOS secondaryText)
      disabled: '#A6A6AD',  // Light gray (iOS tertiaryText)
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
    },
    h2: {
      fontWeight: 600,
      fontSize: '2rem',
    },
    h3: {
      fontWeight: 600,
      fontSize: '1.75rem',
    },
    h4: {
      fontWeight: 600,
      fontSize: '1.5rem',
    },
    h5: {
      fontWeight: 600,
      fontSize: '1.25rem',
    },
    h6: {
      fontWeight: 600,
      fontSize: '1rem',
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
        sizeSmall: {
          padding: '4px 12px',
          fontSize: '0.8125rem',
          borderRadius: 8,
        },
        sizeMedium: {
          padding: '6px 16px',
          borderRadius: 8,
        },
        sizeLarge: {
          padding: '10px 24px',
          borderRadius: 8,
        },
        contained: {
          boxShadow: 'none',
          color: '#ffffff',
          background: 'linear-gradient(135deg, #FF7333 0%, #E6591A 100%)',
          '@media (hover: hover)': {
            '&:hover': {
              boxShadow: '0px 6px 16px rgba(255, 115, 51, 0.3)',
              background: 'linear-gradient(135deg, #FF9959 0%, #FF7333 100%)',
            },
          },
          '&.Mui-disabled': {
            background: '#E0E0E0',
            color: '#9E9E9E',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 8,
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
      },
    },
  },
});

export default theme;
